import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/AcademicErpCrestest.css';

// Feature & Timeline Image Imports (Adjust paths if necessary)
import Why1 from '../../images/associate2.jpg';
import Why2 from '../../images/associate3.jpg';
import featureSectionBg from '../../images/Banner2.png';

function AcademicErpCrestest() {
    const navigate = useNavigate();

    return (
        <section
            className="unique-features-crestest-section"
            style={{ backgroundImage: `url(${featureSectionBg})` }}
        >
            <div className="container py-4">
                <div className="row justify-content-center text-center mb-4">
                    <div className="col-lg-8">
                        <span className="ufc-grid-mini-tag">ASSOCIATIVE ACADEMIC ERP</span>

                        <h2 className="ufc-grid-heading" style={{ color: '#207AB4' }}>
                            Smart ERP Solutions for Schools & Institutes
                        </h2>

                        <div className="ufc-zigzag-border mx-auto mt-2"></div>
                    </div>
                </div>

                <div className="ufc-timeline-wrapper position-relative">
                    {/* Center Straight Vertical Line */}
                    <div className="ufc-timeline-center-line"></div>

                    {/* Timeline Item 1: Facilitate Self Discovery */}
                    <div className="ufc-timeline-row row align-items-center mb-3">
                        <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center mb-2 mb-lg-0">
                            <div className="ufc-timeline-box ufc-timeline-box-left position-relative d-inline-block">
                                <div className="ufc-timeline-arrow-right"></div>
                                <img src={Why1} alt="School ERP" className="ufc-timeline-box-img" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center">
                            <div className="ufc-timeline-box ufc-timeline-box-right position-relative d-inline-block">
                                <div className="ufc-timeline-arrow-left"></div>

                                <span className="ufc-timeline-badge-tag">School ERP</span>

                                <h3 className="ufc-timeline-box-heading">
                                    Smart School Management
                                </h3>

                                <p className="ufc-timeline-box-sub">
                                    Digitally manage admissions, attendance, examinations, fees, academics, communication, and student performance through one secure and intelligent ERP platform.
                                </p>

                                <button
                                    onClick={() => window.open("https://school.crestest.com", "_blank")}
                                    className="ufc-timeline-action-btn text-decoration-none d-inline-block border-0"
                                >
                                    View Demo
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Timeline Item 2: Concept Maps & Content */}
                    <div className="ufc-timeline-row row align-items-center mb-4 flex-row-reverse">
                        <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center mb-2 mb-lg-0">
                            <div className="ufc-timeline-box ufc-timeline-box-right position-relative d-inline-block">
                                <div className="ufc-timeline-arrow-left"></div>
                                <img src={Why2} alt="Institute ERP" className="ufc-timeline-box-img" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center">
                            <div className="ufc-timeline-box ufc-timeline-box-left position-relative d-inline-block">
                                <div className="ufc-timeline-arrow-right"></div>

                                <span className="ufc-timeline-badge-tag">Institute ERP</span>

                                <h3 className="ufc-timeline-box-heading">
                                    Smart Institute Management
                                </h3>

                                <p className="ufc-timeline-box-sub">
                                    Simplify coaching and institute operations with batch management, student records, attendance, online examinations, fee management, and performance analytics—all from one integrated ERP platform.
                                </p>

                                <button
                                    onClick={() => window.open("https://institute.crestest.com", "_blank")}
                                    className="ufc-timeline-action-btn text-decoration-none d-inline-block border-0"
                                >
                                    View Demo
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Explore More Associative Program Call to Action (Given higher z-index to stay above the center line) */}
                    <div className="row justify-content-center text-center mt-5 pt-3 position-relative" style={{ zIndex: 5 }}>
                        <div className="col-lg-8">
                            <button
                                onClick={() => navigate('/associates')}
                                className="ufc-timeline-action-btn text-decoration-none d-inline-block border-0 px-4 py-2 mt-3"
                                style={{ fontSize: '15px' }}
                            >
                                Explore more about our Associative Program
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default AcademicErpCrestest;